const destroyFns = [];
export default destroyFns;